import PropTypes from 'prop-types';
import React, { useEffect, useRef } from 'react';
import { List } from 'immutable';
import classNames from 'classnames';
import { Link } from 'react-router-dom';

import Offer from '../../../containers/betslip/Offer';
import ActiveFilters from './ActiveFilters';
import IconKeys from './IconKeys/IconKeys';

import FilterIcon from '../../../../../assets/images/icons/misc/filter_dark.svg';

import style from './ActiveBets.module.scss';
import commonStyles from '../stylesheets/shared.module.scss';

const ActiveBets = ({
  tourMode,
  onUpdateOffers,
  onSubmitUnmatched,
  onSubmitOffers,
  onCancelOffers,
  onCancelUnmatchedOffers,
  onReviewOffer,
  currency,
  openOffers,
  fakeOpenOffers,
  activeSports,
  activeFilters,
  setActiveFilters,
  showSettings,
  requestPaginatedData,
  aggregationRule,
}) => {
  const offers = tourMode ? fakeOpenOffers : openOffers;

  const scrollDiv = useRef();

  const onUseBonusUpdate = (cid) => {
    offers.forEach((offer) => {
      if (offer.cid !== cid) {
        onUpdateOffers({
          cid: offer.cid,
          id: offer.id,
          useBonus: false
        });
      }
      return offer;
    });
  };

  useEffect(() => {
    const sd = scrollDiv.current;
    sd.addEventListener('scroll', () => {
      if (Math.floor(sd.scrollHeight - sd.scrollTop) <= sd.clientHeight) {
        requestPaginatedData();
      }
    });
  }, []);

  useEffect(() => {
    scrollDiv.current.scrollTop = 0;
  }, [activeFilters, aggregationRule]);

  const offersClass = classNames({
    [style.offers]: true,
    [style['offers--settingsOpen']]: showSettings,
    [style['offers--unmatched']]: !showSettings,
  });

  let previousIteration = {};

  const bets = offers
    .sortBy(offer => offer.side)
    .sortBy(offer => offer.marketId)
    .sortBy(offer => offer.eventId);

  return (
    <div className={offersClass}>
      <div className={commonStyles.container}>
        <ActiveFilters
          activeSports={activeSports}
          setActiveFilters={setActiveFilters}
          activeFilters={activeFilters}
        />
        <div className={commonStyles.containerScrollable} ref={scrollDiv}>
          {bets.map((offer, index) => {
            const arr = [];
            if (offer.eventId !== previousIteration.eventId) {
              arr.push(
                <div className={commonStyles.containerHeader} key={offer.id}>
                  <Link
                    to={`/events/${offer.eventId}`}
                    className={commonStyles.eventLink}
                  >
                    <span>{offer.eventName}</span>
                  </Link>
                  <div className={commonStyles.containerSecondRow}>
                    <span>Odds</span>
                    <span className={style.marginTitles}>Stake</span>
                    <span>PnL</span>
                  </div>
                </div>
              );
            }
            arr.push(<Offer
              isActiveOffer
              offerIndex={index}
              offer={offer}
              onUpdateOffer={onUpdateOffers}
              onSubmitOffer={onSubmitOffers}
              onSubmitUnmatched={onSubmitUnmatched}
              onCancelOffer={onCancelOffers}
              onCancelUnmatchedOffers={onCancelUnmatchedOffers}
              onReviewOffer={onReviewOffer}
              onUseBonusUpdate={onUseBonusUpdate}
              key={`offer_${offer.cid}_${offer.id}`}
              currency={currency}
            />);

            previousIteration = offer;
            return arr;
          }).toArray()}
          {bets.size !== 0 && <IconKeys />}
          {bets.size === 0 && activeFilters.sport !== 'dynamic' && (
            <div className={commonStyles.noOffers}>
              <span className={style.noOffersLabel}>No Selections</span>
            </div>
          )}
          {bets.size === 0 && activeFilters.sport === 'dynamic' && (
            <div className={style.noOffers}>
              <div className={style.iconRow}>
                <FilterIcon />
              </div>
              <span className={style.noOffersLabel}>
                There are no bets that match<br />
                your current filter
              </span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

ActiveBets.propTypes = {
  onUpdateOffers: PropTypes.func.isRequired,
  setActiveFilters: PropTypes.func.isRequired,
  onSubmitOffers: PropTypes.func.isRequired,
  onSubmitUnmatched: PropTypes.func.isRequired,
  onCancelOffers: PropTypes.func,
  onCancelUnmatchedOffers: PropTypes.func,
  onReviewOffer: PropTypes.func,
  currency: PropTypes.string,
  aggregationRule: PropTypes.string.isRequired,
  requestPaginatedData: PropTypes.func.isRequired,
  showSettings: PropTypes.bool,
  tourMode: PropTypes.bool.isRequired,
  openOffers: PropTypes.instanceOf(List).isRequired,
  fakeOpenOffers: PropTypes.instanceOf(List).isRequired,
  activeSports: PropTypes.instanceOf(List).isRequired,
  activeFilters: PropTypes.instanceOf(Object),
};

export default ActiveBets;
